import { useTranslation } from 'react-i18next';

import { AlertBox, Card } from 'components';
import { getPremiumStyled, RETURN_VALUE_ONLY } from 'enrollment/utils';

type ContributionBenefitTileProps = {
  title: string;
  benefits: BenefitChipData[];
  greenCard?: boolean;
};

export type BenefitChipData = {
  name: string;
  amount: number;
  carrierName: string;
  carrierImageSrc: string;
  useByDate?: string;
};

export function ContributionBenefitTile({
  title,
  benefits,
  greenCard = false,
}: ContributionBenefitTileProps) {
  const { t } = useTranslation('pages.home');
  const imageWidth = '100%';
  const imageHeight = 'fit-content';

  return (
    <>
      <h3 data-testid="contribution-benefit-tile-title">{title}</h3>

      <div data-testid="contribution-benefit-tile-benefits-container">
        {benefits.map((benefit) => {
          return (
            <Card
              key={`contribution-${benefit.carrierName}`}
              additionalClasses={`p-4 d-flex w-100 justify-content-between yoyoyo ${greenCard && 'border-success'}`}
              dataTestId="contribution-benefit-tile-benefit-card"
            >
              <div>
                <p
                  className="body1"
                  data-testid="contribution-benefit-tile-benefit-card-benefit-name"
                >
                  {benefit.name}
                </p>
                {/* className="my-0"  */}
                <h2 data-testid="contribution-benefit-tile-benefit-card-benefit-amount">
                  {getPremiumStyled({
                    premium: String(benefit.amount),
                    valueOnly: RETURN_VALUE_ONLY,
                  })}
                </h2>
                <p className="text-sm text-neutral-700 mt-1" data-testid="contribution-benefit-tile-benefit-card-benefit-label">
                  {t('accountsOtherBenefits.annualContribution')}
                </p>
                {benefit.useByDate && (
                  <div className="mt-3">
                    <AlertBox
                      innerText={`${t('accountsOtherBenefits.useBy')} ${benefit.useByDate}`}
                      data-testid="contribution-benefit-tile-benefit-card-benefit-name"
                    />
                  </div>
                )}
              </div>

              <img
                data-testid="contribution-benefit-tile-benefit-card-benefit-carrier-image"
                src={benefit.carrierImageSrc}
                alt={`${benefit.carrierName}-logo`}
                style={{
                  maxWidth: imageWidth,
                  maxHeight: imageHeight,
                }}
                className="d-none d-md-block"
              />
            </Card>
          );
        })}
      </div>
    </>
  );
}
